import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type SetSequencePositionMutationVariables = Types.Exact<{
  input: Types.SetSequencePositionInput;
}>;


export type SetSequencePositionMutation = { __typename?: 'Mutation', setSequencePosition?: boolean | null };


export const SetSequencePosition = /*#__PURE__*/ gql`
    mutation SetSequencePosition($input: SetSequencePositionInput!) {
  setSequencePosition(input: $input)
}
    ` as unknown as DocumentNode<SetSequencePositionMutation, SetSequencePositionMutationVariables>;

          

          export const useSetSequencePositionMutation = (options?:MutationHookOptions<SetSequencePositionMutation, SetSequencePositionMutationVariables>) => useMutation(SetSequencePosition, options);
          

          export type SetSequencePositionMutationOptions = MutationHookOptions<SetSequencePositionMutation, SetSequencePositionMutationVariables>;

          

          export type SetSequencePositionMutationResult = ReturnType<typeof useSetSequencePositionMutation>[1];

          
